import React from 'react';

const QuestComponentLayout = props => <div>{props.children}</div>;

export default QuestComponentLayout;
